import { PropsWithChildren, createContext, useContext, useState } from "react";

import { SelectItem } from "@fronterahealth/frontera-ui-components";

import { ApiLearnerFileStatusChoices } from "@api/graphql/types-and-hooks";

interface ClinicalReportDataI {
  uploadedFileMeta: LearnerFileMeta | null;
  setUploadedFileMeta: (val: LearnerFileMeta | null) => void;
  selectedEHRClient: SelectItem | undefined;
  setSelectedEHRClient: React.Dispatch<React.SetStateAction<SelectItem | undefined>>;
  isClientImportedFromEHR: boolean;
  setIsClientImportedFromEHR: React.Dispatch<React.SetStateAction<boolean>>;
}

interface LearnerFileMeta {
  id: string;
  status: ApiLearnerFileStatusChoices | undefined;
}

const EHRClientContext = createContext<ClinicalReportDataI | undefined>(undefined);

export const useEHRClientData = () => {
  const context = useContext(EHRClientContext);
  if (context === undefined) {
    throw new Error("Route must be wrapped with EHRClientProvider");
  }
  return context;
};

export const EHRClientProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [uploadedFileMeta, setUploadedFileMeta] = useState<LearnerFileMeta | null>(null);
  const [selectedEHRClient, setSelectedEHRClient] = useState<SelectItem | undefined>();
  const [isClientImportedFromEHR, setIsClientImportedFromEHR] = useState<boolean>(false);
  return (
    <EHRClientContext.Provider
      value={{
        uploadedFileMeta,
        setUploadedFileMeta,
        selectedEHRClient,
        setSelectedEHRClient,
        isClientImportedFromEHR,
        setIsClientImportedFromEHR,
      }}
    >
      {children}
    </EHRClientContext.Provider>
  );
};
